<div class="header">
  @if (configuration?.header) {
    <h3 class="card__title">{{ configuration?.header }}</h3>
  } @else {
    <h3 class="card__title" i18n="@@sr_list_widget.card.empty_header">Header not set</h3>
  }
  <p-button
    pTooltip="Actions"
    i18n-pTooltip="@@common.button.actions"
    tooltipPosition="bottom"
    icon="pi pi-ellipsis-v"
    [rounded]="true"
    [text]="true"
    size="small"
    (click)="actionMenu.toggle($event)" />
  </div>

  <div #responsiveWidgetTable>
    @if (!isEditing) {
      @if ((serviceRequests$ | async)?.totalCount === 0) {
        <div class="empty-placeholder">
          <p i18n="@@sr_list_widget.card.empty_placeholder">No service requests to display</p>
        </div>
      } @else {
        <p-table [value]="(serviceRequests$ | async)?.data || []" stripedRows>
          <ng-template pTemplate="header">
            <tr carehub-table-header [config]="getVisibleHeaderConfig()"></tr>
          </ng-template>
          <ng-template pTemplate="body" let-serviceRequest>
            <tr class="row">
              <td
                [ngClass]="{ 'row__column--hidden': !isColumnVisible(1) }"
                [pTooltip]="serviceRequest.title"
                tooltipPosition="bottom">
                {{ serviceRequest.title }}
              </td>
              <td [ngClass]="{ 'row__column--hidden': !isColumnVisible(1) }">
                <p-tag
                  class="row__status"
                  [value]="serviceRequest.status"
                  [styleClass]="'row__status--' + formatStatusLabel(serviceRequest.status)">
                </p-tag>
              </td>
              <td
              [ngClass]="{
                'row__assigned--unassigned': serviceRequest.assignedTo === 'Unassigned',
                'row__column--hidden': !isColumnVisible(3),
              }">
                {{ serviceRequest.assignedTo }}
              </td>
              <td [ngClass]="{ 'row__column--hidden': !isColumnVisible(2) }">
                @if (serviceRequest.priority > 0) {
                  <p-badge
                    class="row__priority"
                    [value]="serviceRequest.priority"
                    [styleClass]="'row__priority--' + serviceRequest.priority" />
                }
              </td>
              <td [ngClass]="{ 'row__column--hidden': !isColumnVisible(4) }">
                {{ serviceRequest.createdDate | date: 'dd/MM/yyyy' }}
              </td>
              <td class="row__actions">
                <p-button
                  pTooltip="Join chat"
                  i18n-pTooltip="@@common.button.join_chat"
                  tooltipPosition="bottom"
                  icon="pi pi-send"
                  iconPos="right"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  (click)="startTeamsChat(serviceRequest)" />
                  <a
                    [routerLink]="['/utilities/service-requests/', serviceRequest.id]"
                    class="p-button p-button-icon-only p-button-rounded p-button-text p-button-sm"
                    pTooltip="View"
                    i18n-pTooltip="@@common.button.edit"
                    tooltipPosition="bottom"
                    (click)="$event.stopPropagation()">
                    <i class="pi pi-eye"></i>
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="0"
            [rows]="(serviceRequests$ | async)?.pageSize"
            [totalRecords]="(serviceRequests$ | async)?.totalCount" />
          }
        } @else {
          <div class="edit-container">
            <carehub-service-request-list-configuration
              [initialConfigurationuration]="configuration"
              #configurationComponent>
            </carehub-service-request-list-configuration>
            <div class="edit-container__actions">
              <p-button label="Cancel" severity="secondary" (onClick)="onConfigurationCancel()">
              </p-button>
              <p-button
                label="Update"
                (onClick)="onConfigurationUpdate()"
                [disabled]="!isConfigurationValid()">
              </p-button>
            </div>
          </div>
        }
      </div>

      <p-menu #actionMenu [model]="actionMenuItems" [popup]="true" appendTo="body"> </p-menu>
